import { Badge } from "react-bootstrap";
import "./style.css";
import HeaderColumn from "../components/HeaderColumn";

export const tableInfo = (
  data,
  setFiltersField,
  setOrder,
  setOrderField,
  estado_id,
  setActaAImprimir,
  setActaADesasignar
) => {
  const columns = [
    { field: "id", headerName: "ID", hide: true },
    {
      field: "fecha_hora",
      headerName: "Fecha Hora",
      headerClassName: "custom-header",
      minWidth: 180,
      flex: 1,
      sortable: false,
      renderHeader: () => {
        return (
          <div className="d-flex w-100 justify-content-center mx-auto">
            <HeaderColumn
              label={"Fecha"}
              color={[8, 9, 10].includes(estado_id) ? "#111" : "#FFF"}
              setFiltersField={setFiltersField}
              setOrder={setOrder}
              setOrderField={setOrderField}
              typeInput={"date"}
              field={"fecha_hora"}
              place={"Fecha"}
            />
          </div>
        );
      },
      // renderCell: (params) => {
      //   return <div className=" text-center w-100">{params.row.fecha_hora}</div>;
      // },
    },
    {
      field: "numero_acta",
      headerName: "Acta",
      minWidth: 100,
      flex: 0.5,
      sortable: false,
      renderHeader: () => {
        return (
          <HeaderColumn
            label={"N° Acta"}
            color={[8, 9, 10].includes(estado_id) ? "#111" : "#FFF"}
            setFiltersField={setFiltersField}
            setOrder={setOrder}
            setOrderField={setOrderField}
            typeInput={"number"}
            field={"numero_acta"}
            place={"Acta"}
          />
        );
      },
    },
    ...(estado_id == 12
      ? [
          {
            field: "motivo",
            headerName: "Motivo",
            minWidth: 160,
            flex: 2,
            sortable: false,
            renderHeader: () => {
              return (
                <HeaderColumn
                  label={"Motivo"}
                  color={[8, 9, 10].includes(estado_id) ? "#111" : "#FFF"}
                  setFiltersField={setFiltersField}
                  setOrder={setOrder}
                  setOrderField={setOrderField}
                  typeInput={"select"}
                  field={"motivo"}
                  place={"Motivo"}
                />
              );
            },
            renderCell: (params) => {
              return (
                <>
                  <Badge bg="danger">{params?.row?.motivo}</Badge>
                </>
              );
            },
          },
        ]
      : []),
    {
      field: "infraccion",
      headerName: "Infraccion",
      minWidth: 150,
      flex: 1,
      sortable: false,
      renderHeader: () => {
        return (
          <HeaderColumn
            label={"Tipo infracción"}
            color={[8, 9, 10].includes(estado_id) ? "#111" : "#FFF"}
            setFiltersField={setFiltersField}
            setOrder={setOrder}
            setOrderField={setOrderField}
            typeInput={"select"}
            field={"tipo"}
            place={"Tipo"}
          />
        );
      },
    },
    {
      field: "plate",
      headerName: "Patente",
      minWidth: 100,
      flex: 1,
      sortable: false,
      renderHeader: () => {
        return (
          <HeaderColumn
            label={"Patente"}
            color={[8, 9, 10].includes(estado_id) ? "#111" : "#FFF"}
            setFiltersField={setFiltersField}
            setOrder={setOrder}
            setOrderField={setOrderField}
            typeInput={"text"}
            field={"plate"}
            place={"Patente"}
          />
        );
      },
    },
    {
      field: "localidad",
      headerName: "Localidad",
      minWidth: 150,
      flex: 3,
      sortable: false,
      renderHeader: () => {
        return (
          <HeaderColumn
            label={"Localidad"}
            color={[8, 9, 10].includes(estado_id) ? "#111" : "#FFF"}
            setFiltersField={setFiltersField}
            setOrder={setOrder}
            setOrderField={setOrderField}
            typeInput={"text"}
            field={"localidad"}
            place={"Localidad"}
          />
        );
      },
    },
    {
      field: "documento",
      headerName: "Documento",
      minWidth: 140,
      flex: 1,
      sortable: false,
      renderHeader: () => {
        return (
          <HeaderColumn
            label={"DNI"}
            color={[8, 9, 10].includes(estado_id) ? "#111" : "#FFF"}
            setFiltersField={setFiltersField}
            setOrder={setOrder}
            setOrderField={setOrderField}
            typeInput={"number"}
            field={"documento_titular"}
            place={"Documento"}
          />
        );
      },
    },
    // ...(estado_id === 3
    //   ? [
    //       {
    //         field: "estado",
    //         headerName: "Estado",
    //         minWidth: 200,
    //         flex: 2,
    //         sortable: false,
    //         renderHeader: () => {
    //           return (
    //             <HeaderColumn
    //               label={"Estado"}
    //               color={[8,9,10].includes(estado_id) ? "#111" : "#FFF"}
    //               setFiltersField={setFiltersField}
    //               setOrder={setOrder}
    //               setOrderField={setOrderField}
    //               typeInput={"select"}
    //               field={"estado_id"}
    //               place={"Estado"}
    //             />
    //           );
    //         },
    //         renderCell: (params) => {
    //           console.log(params.row?.estado)
    //           return (
    //             <>
    //               <BadgeEstados estado_id={params.row.estado} />
    //             </>
    //           );
    //         },
    //       },
    //     ]
    //   : []),
    ...([8, 4, 11, 9].includes(estado_id)
      ? [
          {
            field: "notificador_nombre",
            headerName: "Notificador",
            minWidth: 300,
            flex: 2,
            sortable: false,
            renderHeader: () => {
              return (
                <HeaderColumn
                  label={"Notificador"}
                  color={[8, 9, 10].includes(estado_id) ? "#111" : "#FFF"}
                  setFiltersField={setFiltersField}
                  setOrder={setOrder}
                  setOrderField={setOrderField}
                  typeInput={"text"}
                  field={"notificador"}
                  place={"Notificador"}
                />
              );
            },
            renderCell: (params) => {
              return (
                <>
                  <span
                    className={`${params.row.tipo_acta_generada == "DIGITAL" ? "  px-2 rounded fw-bold" : params.row.notificador_nombre ? "" : "text-danger"}`}
                  >
                    {params.row.tipo_acta_generada == "DIGITAL"
                      ? "Mi Muni Digital"
                      : params.row.notificador_nombre
                        ? params.row.notificador_nombre
                        : "No tiene notificador"}
                  </span>
                </>
              );
            },
          },
        ]
      : []),

    {
      field: "zona",
      headerName: "Zonas",
      minWidth: 160,
      flex: 2,
      sortable: false,
      renderHeader: () => {
        return (
          <HeaderColumn
            label={"Zona"}
            color={[8, 9, 10].includes(estado_id) ? "#111" : "#FFF"}
            setFiltersField={setFiltersField}
            setOrder={setOrder}
            setOrderField={setOrderField}
            typeInput={"select"}
            field={"zona"}
            place={"zona"}
          />
        );
      },
    },
  ];

  const rows =
    data?.map((d, index) => {
      return {
        id: d?.id,
        fecha_hora: d?.fecha_hora,
        numero_acta: d?.numero_acta,
        infraccion: d?.tipo,
        plate: d?.plate,
        localidad: d?.localidad,
        documento: d?.documento_titular,
        get_acta_fisica: d.get_acta_fisica,
        estado_id: d?.estado_id,
        zona: d.zona,
        user_id_asignado:
          estado_id == 8 && d?.notificadores?.length > 0
            ? d?.notificadores[0]?.user_id_asignado
            : null,
        notificador_nombre:
          (estado_id == 8 || estado_id == 4 || estado_id == 11 || estado_id == 9) &&
          d?.notificadores?.length > 0
            ? d?.notificadores[0]?.persona?.nombre
            : null,
        estado: d?.estado?.id,
        alertas: d?.alertas,
        motivo: estado_id == 12 ? d?.motivo?.nombre : null,
        tipo_acta_generada:
          estado_id == 8 || estado_id == 4 || estado_id == 11 ? d.tipo_acta_generada : null,
        dependencia: d?.dependencia,
        domicilio_notificacion_id: d?.domicilio_notificacion_id,
        baja_tribunal: d?.baja_tribunal,
        bloqueada: d?.bloqueada?.estado,
      };
    }) || [];

  const filter = (d, value) => {
    value = value.toLowerCase();

    return (
      String(d.id)?.toString().toLowerCase().includes(value) ||
      String(d.plate)?.toString().toLowerCase().includes(value) ||
      String(d.fecha_hora)?.toString().toLowerCase().includes(value) ||
      String(d.infraccion)?.toString().toLowerCase().includes(value) ||
      String(d.documento)?.toString().toLowerCase().includes(value) ||
      String(d.localidad)?.toString().toLowerCase().includes(value) ||
      String(d.numero_acta)?.toString().toLowerCase().includes(value) ||
      String(d.numero_acta)?.toString().toLowerCase().includes(value)
    );
  };

  return { columns, rows, filter };
};
